import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { OpsTabs } from '../components/features/ops/OpsTabs.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business オペレーション（opetan）セクションのレイアウト。ヘッダ + セクション内タブ（Queue / システム運用 / New Request / My Requests / Assignments / SLO）を描画し、配下の ops ページを Outlet でラップする。read は社内従業員のみに開放（外部 / 退職者 / システムアカウント division を除外＝isOpsInternalViewer、API の requireOpsViewer と同一述語）。書き込みは PI Div / admin に個別ゲート
 * @graph-connects ProtectedRoute [calls] ページアクセス判定でラップ
 * @graph-connects OpsTabs [calls] セクション内タブナビ描画
 */
export const Route = createFileRoute('/ops')({
  component: OpsLayout,
});

/** @graph-connects none */
function OpsLayout(): ReactNode {
  const { t } = useTranslation();
  return (
    <ProtectedRoute pageKey="operations">
      <div className="mx-auto max-w-6xl space-y-4 px-4 py-6">
        <header>
          <h1 className="text-xl font-bold text-[var(--color-text-primary)]">
            {t('ops.layout.title')}
          </h1>
          <p className="text-sm text-[var(--color-text-muted)]">{t('ops.layout.subtitle')}</p>
        </header>
        <OpsTabs />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}
